import * as axios from "axios";
import { getAuthHeader, getUploadFileHeader } from "./../utils";

export const addComment = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}comment/add`;
  return axios.post(url, model, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const getCommentList = async (code: string) => {
  const url = `${process.env.REACT_APP_BASE_URL}comment/list?c=${code}`;
  return await axios.get(url, getAuthHeader()).then(
    (response: any) => {
      return response.data;
    },
    (error: any) => {
      alert(error.Message);
    }
  );
};

export const uploadAttachment = (model: any) => {
  const url = `${process.env.REACT_APP_BASE_URL}comment/attachment`;
  const formData = new FormData();
  formData.append("fileCode", model.fileCode);
  formData.append("commentCode", model.commentCode);
  formData.append("attachment", model.attachment);

  return axios
    .post(url, formData, getUploadFileHeader())
    .then((response: any) => {
      return response.data;
    });
};
